import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  getAuth,
  setPersistence,
  signInWithPopup,
  signOut as fbSignOut,
} from 'firebase/auth';
import { config } from '../config';

// Public by design, exactly as in the CRM console: a Firebase web config is not
// a secret, and the gate is the staff allowlist on the server.
const FIREBASE_CONFIGS: Record<string, Record<string, string>> = {
  'my-dispatcher-us': {
    apiKey: 'AIzaSyCTmKMmjrLtZ69yl9tV14HMdskAaKyJJOc',
    authDomain: 'my-dispatcher-us.firebaseapp.com',
    projectId: 'my-dispatcher-us',
  },
  'dispatch-system-44a1f': {
    apiKey: 'AIzaSyABPpVvMWsuFoA2xp4lASfCFI5D6bH_1-Q',
    authDomain: 'dispatch-system-44a1f.firebaseapp.com',
    projectId: 'dispatch-system-44a1f',
  },
};

const app = initializeApp(FIREBASE_CONFIGS[config.firebaseProject]);
export const auth = getAuth(app);
void setPersistence(auth, browserLocalPersistence);

/**
 * Google, and only Google: the server refuses any other sign-in provider
 * (middlewares/auth.js). `select_account` because the browser is usually signed
 * in to a personal Google account as well, and without it the popup silently
 * picks whichever one it last used -- which is then refused for being outside
 * the domain, with no way to choose the other short of signing out of Google.
 */
const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export const signIn = () => signInWithPopup(auth, provider);
export const signOut = () => fbSignOut(auth);

/**
 * Never read `auth.currentUser.getIdToken()` at a call site. Firebase refreshes
 * in the background and the token in hand can be minutes stale; going through
 * here means every request gets a live one, and the SDK caches so this is not a
 * round trip per call.
 */
export const getIdToken = async (): Promise<string | null> => {
  const user = auth.currentUser;
  return user ? user.getIdToken() : null;
};
